import { type DSSCalendarServiceType } from "./DSSCalendar.types";

export const LEGEND_ITEMS: {
  type: DSSCalendarServiceType;
  label: string;
}[] = [
  { type: "seaService", label: "SEA SERVICE" },
  { type: "watchkeeping", label: "WATCHKEEPING" },
  { type: "standby", label: "STANDBY" },
  { type: "yard", label: "YARD" },
  { type: "portStay", label: "PORT STAY" },
];
